"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIncludeSubstring = void 0;
function isIncludeSubstring(source, substring, isToLower = true) {
    if (!source) {
        return false;
    }
    if (!substring) {
        return true;
    }
    if (isToLower) {
        return source.toLowerCase().includes(substring.toLowerCase());
    }
    else {
        return source.includes(substring);
    }
}
exports.isIncludeSubstring = isIncludeSubstring;
//# sourceMappingURL=isIncludeSubstring.js.map